import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { UnitOfWorkItem } from "../../utilities/unit-of-work-observer";
import { IncidentRoutes } from "../../constants/incident/incident.constants";
import { IncidentClientModel, IncidentModel, SaveIncidentResponse, IncidentOverrideModel, OverrideIncidentDetailsResponse, ComputeIncidentGracePeriodRequest, ComputeIncidentGracePeriodResponse } from "../../models/incidents/incident.models";

@autoinject
export class IncidentService {

    constructor(private requestClient: RequestClientService) { }

    public getIncidentClientModel(id: number): Promise<IncidentClientModel> {
        return this.requestClient.get(`${IncidentRoutes.GetIncidentClientModel}/${id}`, {});
    }

    public getIncident(id: number): Promise<IncidentModel> {
        return this.requestClient.get(`${IncidentRoutes.GetIncident}/${id}`, {});
    }

    public saveIncident(id: number, syncToMdm:boolean, changes: { [index: string]: UnitOfWorkItem }, cfrId: number, files: File[], isCloseOut: boolean = false): Promise<SaveIncidentResponse> {
        return this.requestClient.postFormData(IncidentRoutes.SaveIncident, { id: id, syncToMdm:syncToMdm, changes: changes, cfrId: cfrId, files, isCloseOut });
    }

    public changeStatus(id: number, incidentStatusId: number, statusSnippet: string, comments: string, meta: string, subtaskTypes: number[], misreportedReasonId?: number): Promise<void> {
        return this.requestClient.post(IncidentRoutes.ChangeStatus, {}, {
            id: id,
            statusSnippet: statusSnippet,
            comments: comments,
            statusId: incidentStatusId,
            meta: meta,
            subtaskTypes: subtaskTypes,
            misreportedReasonId: misreportedReasonId
        });
    }

    public overrideDetails(item: IncidentOverrideModel, submit: boolean, vesselId: number, isClosed: boolean, attachments: File[]): Promise<OverrideIncidentDetailsResponse> {
        return this.requestClient.postFormData(IncidentRoutes.OverrideDetails, {
            item: item,
            submit: submit,
            vesselId: vesselId,
            isClosed: isClosed,
            attachments: attachments
        });
    }
    
    public removeInc(vesselId: number, id: string): Promise<string> {
        return this.requestClient.post<string>(IncidentRoutes.RemoveInc, {}, {
            id: id,
            vesselId: vesselId
        });
    }

    public computeIncidentGracePeriod(request: ComputeIncidentGracePeriodRequest): Promise<ComputeIncidentGracePeriodResponse>{
        return this.requestClient.post<ComputeIncidentGracePeriodResponse>(IncidentRoutes.ComputeIncidentGracePeriod, {}, request);
    }
}